import { ItemData } from 'core/models/Template'

export const SCHOOL_SCHEDULE_TITLE_KEY = 'scheduleClasses' as const
export const SCHOOL_SCHEDULE_MODULE_KEY = 'instancesCatalog/schoolSchedule' as const

export const SCHOOL_SCHEDULE_TABS = ['schoolSchedule', 'downloadFromFile'] as const

export type SchoolScheduleTab = typeof SCHOOL_SCHEDULE_TABS[number]

export const SCHEDULE_CLASSES_CATALOG_TYPE = 'scheduleClasses' as const

export const SCHEDULE_CLASSES_CATALOG_CONFIG = {
    type: SCHEDULE_CLASSES_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export const SCHOOL_SCHEDULE_UPLOAD_METHOD = 'uploadSchoolSchedule' as const

export type SchoolScheduleSelectedItems = ItemData[]

export type SchoolScheduleFilterItem = {
    classNumber: string
    classLetter: string
    day: number
}

export type SchoolScheduleFilterState = {
    selectedClassNumber: string
    selectedClassLetter: string
    day: number
}

export type SchoolScheduleFilterParameter = keyof SchoolScheduleFilterState

export type SchoolScheduleCustomFilterList = (list: SchoolScheduleFilterItem[]) => SchoolScheduleFilterItem[]
